import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { keyIn } from 'utils/immutable';
import DropDownButton from 'components/form/DropDownButton';

class AccountDropDown extends React.Component {
    constructor(props) {
        super(props);

        this.isGatewayAdmin = (
            props.gateway && props.adminForGateways.some(adminGateway => adminGateway.id === props.gateway)
        );
    }

    render() {
        return (
            <div>
                <DropDownButton title={this.props.fullName} label={this.props.fullName}>
                    <div>
                        <ul>
                            <a href={this.props.absoluteUrl}>
                                <li>{gettext('View & Edit Profile')}</li>
                            </a>
                            <a href={Util.reverseURL('dbauth:account_settings')}>
                                <li>{gettext('Account Settings')}</li>
                            </a>

                            {
                                (this.isGatewayAdmin || !!this.props.permissions.length) &&
                                <a href={Util.reverseURL('admin:home')}>
                                    <li>{gettext('Admin Home')}</li>
                                </a>
                            }

                        </ul>
                        <ul>
                            <a href={Util.reverseURL('dbauth:logout')}>
                                <li>{gettext('Sign Out')}</li>
                            </a>
                        </ul>
                    </div>
                </DropDownButton>
                <img
                    className="right"
                    src={this.props.thumbnailUrl}
                    style={{ height: 22, background: this.props.thumbnailBackground }}
                    alt={this.props.fullName}
                />
            </div>
        );
    }
}

AccountDropDown.propTypes = {
    gateway: PropTypes.string,
    permissions: PropTypes.arrayOf(PropTypes.string),
    adminForGateways: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string
    })),
    absoluteUrl: PropTypes.string.isRequired,
    fullName: PropTypes.string.isRequired,
    thumbnailUrl: PropTypes.string.isRequired,
    thumbnailBackground: PropTypes.string
};

AccountDropDown.defaultProps = {
    gateway: '',
    permissions: [],
    adminForGateways: [],
    thumbnailBackground: ''
};

const mapStateToProps = state => Object.assign(
    { gateway: state.getIn(['site', 'gateway']) },
    state
        .get('people')
        .filter(keyIn('absoluteUrl', 'permissions', 'adminForGateways', 'fullName', 'thumbnailUrl'))
        .toJS()
);

export default connect(mapStateToProps)(AccountDropDown);



// WEBPACK FOOTER //
// ./source/containers/SiteHeaderBar/AccountDropDown.jsx